import React from 'react'
import { Outlet } from 'react-router'
import { useAuth } from '@/hooks/useAuth.ts'
import { ModuleFunction } from '@/features/auth/auth.def.ts'

type ProtectedRoutesProps = {
  /** Every permission listed here must be granted. */
  requiredPermissions?: ModuleFunction[]
  /** At least one of the permissions listed here must be granted. */
  anyOfPermissions?: ModuleFunction[]
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({
  requiredPermissions = [],
  anyOfPermissions = [],
}) => {
  const { checkHasAllPermissions, checkHasAnyPermissions } = useAuth()

  if (!checkHasAllPermissions(requiredPermissions)
    || (anyOfPermissions.length && !checkHasAnyPermissions(anyOfPermissions))) {
    throw new Error('Access Denied')
  }

  return <Outlet />
}